import { render, staticRenderFns } from "./Ugrr.vue?vue&type=template&id=4538fa28&scoped=true&"
import script from "./Ugrr.vue?vue&type=script&lang=js&"
export * from "./Ugrr.vue?vue&type=script&lang=js&"
import style0 from "./Ugrr.vue?vue&type=style&index=0&id=4538fa28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4538fa28",
  null
  
)

export default component.exports